import { useState } from "react";
import { shortDateLabel, type DateStr } from "../../lib/date";
import { anchorOf, type Anchor } from "../../state/ui";
import { MiniCalendar } from "../MiniCalendar";
import { Popover } from "./Popover";

/** "seg., 28 de set. de 2026" button opening a month picker. */
export function DateSelect({ value, onChange, today, weekStart, ariaLabel }: { value: DateStr; onChange: (d: DateStr) => void; today: DateStr; weekStart: number; ariaLabel: string }) {
  const [anchor, setAnchor] = useState<Anchor | null>(null);
  return (
    <>
      <button type="button" className="date-btn" aria-label={ariaLabel} onClick={(e) => setAnchor(anchorOf(e.currentTarget))}>
        {shortDateLabel(value)}
      </button>
      {anchor && (
        <Popover anchor={anchor} placement="below" onClose={() => setAnchor(null)} width={256} keepOpen>
          <MiniCalendar
            compact
            value={value}
            today={today}
            weekStart={weekStart}
            onSelect={(d) => {
              onChange(d);
              setAnchor(null);
            }}
          />
        </Popover>
      )}
    </>
  );
}
